import { createContext } from "react";

export interface DeskSubnavContextValue {
  selectedIds: Array<string | number>;
  setSelectedIds: (ids: Array<string | number>) => void;
}

export const DeskSubnavContext = createContext<DeskSubnavContextValue | undefined>(undefined);
